import {
    checkSpecialCharacter,
    validateEmailAddress,
    checkNonNumericCharacter,
} from "../../utils/validation";
import {getRequest} from "../../utils/request";
import APIConfig from "../../config/apiConfig";
import {isProfaneReg} from "../../utils/string";
import {EMAIL_ALREADY_REGISTERED_ERROR, MOBILE_ALREADY_REGISTERED_ERROR} from "./errorUtils";

export const composeValidators = (...validators) => (value, allValues, meta) => {
    return validators.reduce(
        (error, validator) => error || validator(value, allValues, meta),
        undefined,
    );
};

export const regEmailValidate = (email) => {
    return email
        ? !validateEmailAddress(email)
            ? "Email id is not in correct format"
            : undefined
        : "Email id is mandatory";
};

const simpleMemoize = (fn) => {
    let lastArg;
    let lastVal;
    return (arg1, arg2, args3) => {
        if (args3.active === true) {
            if (arg1 !== lastArg) {
                lastArg = arg1;
                lastVal = fn(arg1, arg2);
                return lastVal;
            }
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(lastVal);
            }, 0);
        });
    };
};
//const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const isEmailAlreadyRegistered = async (value) => {
    const axiosConfig = {
        params: {
            email: value,
        },
    };
    const response = await getRequest(APIConfig.CHECK_EMAIL_EXIST, axiosConfig);
    if (response.data.data === true) {
        return EMAIL_ALREADY_REGISTERED_ERROR;
    }
};

export const checkEmailAvailable = simpleMemoize(isEmailAlreadyRegistered);

const isMobileAlreadyRegistered = (isdCode) => async (value) => {
    // console.log(isdCode, value);
    const axiosConfig = {
        params: {
            mobile: value,
            isdCode: isdCode,
        },
    };
    const response = await getRequest(APIConfig.CHECK_MOBILE_EXIST, axiosConfig);
    if (response.data.data === true) {
        return MOBILE_ALREADY_REGISTERED_ERROR;
    }
};

export const checkMobileAvailable = isMobileAlreadyRegistered;

export const regRequiredValidate = (msg = `Required`, enabled = true) => (value) => {
    //special check if a text contain all whitespaces

    if (typeof value === "string" && value.trim().length <= 0) {
        value = undefined;
    }

    if (typeof value === "boolean") {
        return enabled && value ? undefined : msg;
    }
    // console.log("hi");
    // console.log(
    //     enabled
    //         ? value !== undefined && value !== null
    //             ? undefined
    //             : msg
    //         : undefined,
    // );
    return enabled ? (value !== undefined && value !== null ? undefined : msg) : undefined;
};

export const regSpecialCharacterValidate = (msg = `No Special characters allowed in name`) => (
    value,
) => {
    return checkSpecialCharacter(value) ? undefined : msg;
};

export const regProfanityWordsValidate = (msg) => (value) => {
    return isProfaneReg(value) ? msg : undefined;
};

export const regNumberValidate = (msg = `No Special characters allowed in name`) => (value) => {
    return checkNonNumericCharacter(value) ? undefined : msg;
};

export const minLengthValidate = (min, msg = `Should be greater than ${min}`) => (value) => {
    return value.length >= min ? undefined : msg;
};

export const maxLengthValidate = (max, msg = `Should be less than ${max}`) => (value) => {
    return value.length <= max ? undefined : msg;
};

export const startingDigitValidation = (startingDigitList) => (value) => {
    let firstDigit = parseInt(value.charAt(0));
    return startingDigitList.includes(firstDigit) ? undefined : "Invalid mobile number";
};

export const validateLevelForExamStatus = (level) => () => {
    return level ? undefined : "Please select course level before selecting exams information";
};

export const numberValidation = (minValue, maxValue, step, msg) => (value) => {
    return value && (value < minValue || value > maxValue || value % step !== 0)
        ? msg
            ? msg
            : `Please enter a valid score between ${minValue} and ${maxValue}`
        : undefined;
};

export const validateExamScoreField = (value, allValues) => {
    const {examScore} = allValues;
    let error = true;
    examScore &&
        examScore.map((exam) => {
            if (exam.enabled === true || value === true) error = false;
        });
    return error ? "Please select atleast one exam" : undefined;
};

export const validateNewConfirmPasswordField = (msg = `Password doesn't match`) => (
    value,
    allValues,
) => {
    const {newPassword, newConfirmPassword} = allValues;
    let error = false;
    if (newPassword !== newConfirmPassword) {
        error = true;
    }
    return error ? msg : undefined;
};
